import FormGenerator from '../form/FormGenerator'
import { FormRow } from '../../../generated-types/form-field'
import { useCustomerCtx } from '../../../hooks/context-hooks'
import { IFormSchemaGeneric, SchemaType } from '../../../generated-types/form-schema'
import { useNavigate } from 'react-router-dom'
import { AppRoutesNavigation } from '../../../app-routes'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useAddFormSchema, invalidateSchemaForm } from '../../../api/form-schema'

const AddChecklistTemplate = () => {
  const { customer } = useCustomerCtx()
  const navigate = useNavigate()
  const { t } = useTranslation(['common', 'checklist'])
  const addFormSchema = useAddFormSchema(customer.id)

  return (
    <FormGenerator
      schemaType={SchemaType.Checklist}
      onCancel={() => {
        navigate(AppRoutesNavigation.Customer.checklistTemplates(customer?.id))
      }}
      buttonTitle={t('save')}
      onSubmit={async (value: FormRow[], details: IFormSchemaGeneric) => {
        const checklistTemplate = {
          name: details.name,
          description: details.description,
          hasVideoUpload: details.hasVideoUpload,
          isActive: details.isActive,
          schemaType: details.schemaType ?? SchemaType.Checklist,
          customerId: customer.id,
          versions: [
            {
              layout: JSON.stringify(value),
              version: 1,
            },
          ],
        }

        await addFormSchema.mutateAsync(checklistTemplate, {
          onSuccess: () => {
            invalidateSchemaForm.getAllFormSchema(customer.id)
            toast.success(t('checklist-added-successfully', { ns: 'checklist' }))
            navigate(AppRoutesNavigation.Customer.checklistTemplates(customer?.id))
          },
          onError: () => {
            toast.error(t('InternalError', { ns: 'common-api-message' }))
          },
        })
      }}
    />
  )
}

export default AddChecklistTemplate
